import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fec992a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body" }

import { FormContainerGroup } from '@/components/business/crud/widgets/FormWidgetContainer';
import { h } from 'vue';
import { Icon } from '@/components/common/Icon';
import { Tooltip } from 'ant-design-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetFormGroup',
  props: {
    group: {}
  },
  setup(__props: any) {

const props = __props;

function titleNode(title: string, desc?: string) {
  const slot = () => {
    return [
      title,
      desc
        ? h(
            Tooltip,
            {
              placement: 'topLeft',
              overlayStyle: { whiteSpace: 'pre-line' },
              title: desc,
            },
            {
              default: () =>
                h(Icon as any, {
                  type: 'QuestionCircleFilled',
                  style: {
                    padding: '4px 4px 4px 8px',
                    color: '#333',
                    marginRight: 'unset',
                  },
                }),
            }
          )
        : undefined,
    ];
  };

  return h('div', null, { default: slot });
}

return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.group.inline.length > 0)
      ? (_openBlock(), _createBlock(_component_a_descriptions, {
          key: 0,
          class: "form-group-block",
          bordered: "",
          size: "small",
          column: 2
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.inline, (item) => {
              return (_openBlock(), _createBlock(_component_a_descriptions_item, {
                label: titleNode(item.title, item.desc),
                key: item.id,
                span: item.size === 'small' ? 1 : 2
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.component.value), _normalizeProps(_guardReactiveProps(item.props)), null, 16))
                ]),
                _: 2
              }, 1032, ["label", "span"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.group.block.length > 0)
      ? (_openBlock(), _createBlock(_component_a_tabs, {
          key: 1,
          type: "card",
          tabBarGutter: 8,
          style: {"overflow":"visible"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.group.block, (item) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: item.id,
                tab: titleNode(item.title, item.desc)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.component.value), _normalizeProps(_guardReactiveProps(item.props)), null, 16))
                  ])
                ]),
                _: 2
              }, 1032, ["tab"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})